import * as Sentry from '@sentry/react';
import ErrorType from '../models/error';

export default function useErrorHandler() {
  function handle(err: any) {
    if (err?.message === 'Already paid.') {
      alert('您已購買過該課程！');
      return;
    }

    if (err?.message !== undefined) err = err.message;

    switch (err) {
      case ErrorType.TOKEN_EXPIRED:
        // @ts-ignore
        window.location.href = '/login?url=' + window.location.pathname;
        return;
      case ErrorType.COUPON_NOT_FOUND:
        alert('查無折扣代碼！');
        return;
      case ErrorType.COUPON_EXPIRED:
        alert('折扣代碼已過期！');
        return;
      case ErrorType.COUPON_LIMITED:
        alert('折扣代碼已兌換完畢！');
        return;
      case ErrorType.COUPON_NOT_START_YET:
        alert('折扣代碼還不可使用！');
        return;
      default:
        Sentry.captureException(err);
        alert('發生例外錯誤，如果問題持續存在，請聯繫客服人員處理');
        console.error('Hoost Web Service got this unexpect error:');
        console.error(err);
    }
  }

  return { handle };
}
